var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPortfolio(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 20,
    viewBox: "0 0 22 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3247 7.75V6.625C18.3247 4.76104 16.8704 3.25 15.0763 3.25H11.7227C11.1448 3.25 10.5773 3.0898 10.0788 2.78592L7.91049 1.46408C7.41201 1.1602 6.84453 1 6.26659 1H4.24839C2.45435 1 1 2.51104 1 4.375V15.625C1 17.489 2.45435 19 4.24839 19H13.7069C15.2282 19 16.6381 18.1707 17.4208 16.8152L20.688 11.1576C21.5541 9.65794 20.5144 7.75 18.8311 7.75H18.3247ZM18.3247 7.75H9.2287C7.51706 7.75 5.96597 8.7973 5.27081 10.4224L2.0828 17.875",
    stroke: "#18417E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPortfolio);
export default __webpack_public_path__ + "static/media/portfolio.46cac432345361b5edc2b03e8dab39ab.svg";
export { ForwardRef as ReactComponent };